module.exports = __webpack_public_path__ + "static/boundless-opportunity-d7773a332d1696d1360d322a7747b172.jpg";